module.exports = __webpack_public_path__ + "img/ic_clock.a820f77c.svg";